// 'use client';
// import React from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation } from 'swiper/modules';
// import { FaArrowRight, FaArrowLeft } from 'react-icons/fa6';
// import ProductCard from '@/features/product-card/components/productCard';
// import Link from 'next/link';
// const RecommendedForYou = ({
//   title,
//   showBtn,
//   products,
// }: {
//   title: string;
//   showBtn?: boolean;
//   products?: any;
// }) => {
//   return (
//     <section className="product-feature padding-top padding-bottom">
//       <div className="container">
//         <div className="section-header">
//           <div className="section-header__content">
//             <h2>{title}</h2>
//           </div>
//           {showBtn ? (
//             <>
//               <div className="product-btn order-sm-2 order-lg-3">
//                 <Link className="trk-btn" href="/hot-deals">
//                   View all
//                 </Link>
//               </div>
//             </>
//           ) : (
//             <div className="section-header__action d-none d-sm-block">
//               <div className="swiper-nav swiper-nav--style1">
//                 <button className="swiper-nav__btn product__slider-prev">
//                   <FaArrowLeft />
//                 </button>
//                 <button className="swiper-nav__btn product__slider-next active">
//                   <FaArrowRight />
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//         <div
//           className="product__wrapper"
//           // data-aos="fade-up"
//           // data-aos-duration={1000}
//         >
//           <div className="product-feature__slider">
//             <Swiper
//               modules={[Navigation]}
//               spaceBetween={8}
//               loop={true}
//               slidesPerView={2}
//               grabCursor={true}
//               breakpoints={{
//                 576: {
//                   slidesPerView: 2.5,
//                   spaceBetween: 16,
//                 },
//                 768: {
//                   slidesPerView: 3,
//                   spaceBetween: 24,
//                 },
//                 992: {
//                   slidesPerView: 4,
//                 },
//                 1200: {
//                   slidesPerView: 5,
//                 },
//               }}
//               speed={500} // Smooth transition speed
//               navigation={{
//                 nextEl: '.product__slider-next',
//                 prevEl: '.product__slider-prev',
//               }}
//             >
//               {products?.length > 0 &&
//                 products?.map((product: any, i: number) => (
//                   <SwiperSlide key={i}>
//                     <ProductCard data={product} />
//                   </SwiperSlide>
//                 ))}
//             </Swiper>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default RecommendedForYou;

// src/features/Recommended-For-You/components/RecommendedForYou.tsx

// NO 'use client'. This is a powerful Server Component.

// 'use client';
// import Link from 'next/link';
// import { fetcher } from '@/lib/fetcher';
// import { FaArrowLeft, FaArrowRight } from 'react-icons/fa6';
// import { RecommendedSlider } from './RecommendedSlider';

// type RecommendationType = 'recommended' | 'new_arrivals';

// interface Props {
//   type: RecommendationType;
//   title: string;
//   showBtn?: boolean;
// }

// // The component is now ASYNC
// const RecommendedForYou = async ({ type, title, showBtn }: Props) => {
//   let products = [];

//   // ✅ DATA FETCHING LOGIC IS NOW INSIDE THE COMPONENT
//   try {
//     if (type === 'recommended') {
//       const recommends = await fetcher(
//         '/api/v2/gigalogy/users/search/recommend'
//       );
//       products = recommends?.data ?? [];
//     } else if (type === 'new_arrivals') {
//       const homeThings = await fetcher('/api/v2/home-things?for=desktop');
//       products = homeThings?.new_products ?? [];
//     }
//   } catch (error) {
//     console.error(`Failed to fetch ${type} products:`, error);
//     // In case of an API error, we render nothing.
//     return null;
//   }

//   if (products.length === 0) {
//     return null; // Don't render if there are no products
//   }

//   // Create unique class names for navigation to avoid conflicts
//   const navPrevClass = `product__slider-prev-${type}`;
//   const navNextClass = `product__slider-next-${type}`;

//   return (
//     <section className="product-feature padding-top padding-bottom">
//       <div className="container">
//         {/* The header is now static HTML from the server */}
//         <div className="section-header">
//           <div className="section-header__content">
//             <h2>{title}</h2>
//           </div>
//           {showBtn ? (
//             <div className="product-btn order-sm-2 order-lg-3">
//               <Link className="trk-btn" href="/products">
//                 View all
//               </Link>
//             </div>
//           ) : (
//             <div className="section-header__action d-none d-sm-block">
//               <div className="swiper-nav swiper-nav--style1">
//                 {/* Add the unique classes to the buttons */}
//                 <button className={`swiper-nav__btn ${navPrevClass}`}>
//                   <FaArrowLeft />
//                 </button>
//                 <button className={`swiper-nav__btn ${navNextClass} active`}>
//                   <FaArrowRight />
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//         <div className="product__wrapper">
//           {/* Pass the data and nav classes to the client slider */}
//           <RecommendedSlider
//             products={products}
//             navPrev={navPrevClass}
//             navNext={navNextClass}
//           />
//         </div>
//       </div>
//     </section>
//   );
// };

// export default RecommendedForYou;

'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
// import { fetcher } from '@/lib/fetcher';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa6';
import { RecommendedSlider } from './RecommendedSlider'; // Assuming this is your slider component
import { RecommendedForYouSkeleton } from './RecommendedForYouSkeleton'; // The skeleton we just created
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import {
  API_GIGALOGY_USERS_RECOMMEND,
  API_HOME_THINGS,
} from '@/constant/apiRout';
type RecommendationType =
  | 'recommended'
  | 'new_arrivals'
  | 'international_brands';

interface Props {
  type: RecommendationType;
  title: string;
  className: string;
  showBtn?: boolean;
}

const RecommendedForYou = ({ type, title, showBtn, className }: Props) => {
  const { data: homeThings, isLoading: n } = useFetcherCSR(API_HOME_THINGS);
  const { data: recommends, isLoading: r } = useFetcherCSR(
    type === 'recommended' ? API_GIGALOGY_USERS_RECOMMEND : ''
  );
  const fetchedProducts = homeThings?.new_products;
  const recommendsProduct = recommends?.data;
  const international_brands = homeThings?.international_brands;
  // State to hold the products and loading status

  // Create unique class names for navigation to avoid conflicts
  const navPrevClass = `product__slider-prev-${type}`;
  const navNextClass = `product__slider-next-${type}`;

  if (
    type === 'recommended' &&
    !homeThings?.homepage_settings?.features?.recommendation
  )
    return null;

  if (n || r) {
    return <RecommendedForYouSkeleton showBtn={showBtn} />;
  }

  // 3. Render the full component with data
  return (
    <section className={className}>
      <div className="container">
        <div className="section-header">
          <div className="section-header__content">
            <h2 className="margin-top-10">{title}</h2>
          </div>
          {showBtn ? (
            <div className="product-btn order-sm-2 order-lg-3">
              <Link className="trk-btn" href="/shop">
                View all
              </Link>
            </div>
          ) : (
            <div className="section-header__action d-none d-sm-block">
              <div className="swiper-nav swiper-nav--style1">
                <button className={`swiper-nav__btn ${navPrevClass}`}>
                  <FaArrowLeft />
                </button>
                <button className={`swiper-nav__btn ${navNextClass} active`}>
                  <FaArrowRight />
                </button>
              </div>
            </div>
          )}
        </div>
        <div className="product__wrapper">
          <RecommendedSlider
            products={
              type === 'recommended'
                ? recommendsProduct
                : type === 'new_arrivals'
                  ? fetchedProducts
                  : type === 'international_brands'
                    ? international_brands
                    : []
            }
            navPrev={navPrevClass}
            navNext={navNextClass}
          />
        </div>
      </div>
    </section>
  );
};

export default RecommendedForYou;
